import { Select } from "antd"
import React, { useEffect, useState } from "react"
import ContractCustomerService from "src/services/CustomerContractService"
import DropdownService from "src/services/DropdownService"
import UserManagement from "src/services/UserManagement"

const removeVietnameseTones = str => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // bỏ dấu
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .toLowerCase()
}
// ADMIN/LEADER/STAFF
const SelectCustomerB2B = ({
  value,
  onChange,
  disabled,
  style = { height: "36px" },
  placeholder = "Chọn khách hàng",
}) => {
  const [customerList, setCustomerList] = useState([])

  useEffect(() => {
    fetchCustomerList()
  }, [])

  const fetchCustomerList = async () => {
    try {
      // const type = ["LEADER"]
      const response = await DropdownService.getListCustomerB2B({
        is_locked: [0],
      })
      setCustomerList(response.success || [])
    } catch (error) {
      console.error("Error fetching customer list:", error)
    }
  }

  return (
    <Select
      showSearch
      placeholder={placeholder}
      title={placeholder}
      allowClear
      value={value}
      onChange={onChange}
      filterOption={(input, option) => {
        const inputNormalized = removeVietnameseTones(input)
        const optionText = removeVietnameseTones(option.children)
        return optionText.includes(inputNormalized)
      }}
      style={style}
      disabled={disabled}
    >
      {customerList.map(customer => (
        <Select.Option key={customer.ID} value={customer.ID}>
          {customer.fullname}
        </Select.Option>
      ))}
    </Select>
  )
}

export default SelectCustomerB2B
